import { gql } from '@apollo/client'

export const UPDATE_REMINDER_DATE = gql`
  mutation UpdateReminderDate ($idReminder: Int!, $visualized: Boolean!){
  updateReminderDate(idReminder: $idReminder, visualized: $visualized) 
}
`

